import { useCallback, useEffect, useState } from 'react';
import { SociogramApi } from '@BUP/services/Axios';

export const useSurveyByUser = (user) => {
  const courseId = user?.courseId;
  const organizationId = user?.organizations?.id;
  const [listState, setListState] = useState({
    isLoading: false,
    data: {},
    error: null,
  });

  const getSurveyByUser = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const { data } = await SociogramApi.get(
        // `/surveys?courseId=39&organizationId=7`
        `/surveys?courseId=${courseId}&organizationId=${organizationId}`
      );
      const survey = data?.[0];
      setListState((prevState) => ({
        ...prevState,
        data: survey || {},
      }));
    } catch (error) {
      console.log('useSurveyByUser error', error);
      setListState((prevState) => ({
        ...prevState,
        error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  }, [setListState, organizationId, courseId]);

  useEffect(() => {
    if (organizationId && courseId) getSurveyByUser();
  }, [organizationId, courseId]);

  return {
    isLoadingSurvey: listState.isLoading,
    survey: listState.data,
    errorSurvey: listState.error,
  };
};
